import UserSearchContainer from './UserSearchContainer'

function UserSearchScreen(): JSX.Element {
    return <UserSearchContainer />
}

export default UserSearchScreen
